<template>
  <span>
    <a
      data-id="mPower-delete-btn"
      data-cy="delete-button"
      @click.prevent="$refs.container.show()"
      :disabled="loading || disabled || loadingProgress"
      :class="btnClass ? btnClass : ''"
      href="javascript:;"
      v-b-tooltip.hover
      :title="labelInfo"
    >
      <i v-if="loading || loadingProgress" class="far fa-spinner-third fa-spin"></i>
      <button
        v-else-if="label && !isIcon"
        class="btn btn-primary btn-block"
        :disabled="disabled || loadingProgress || loading"
      >
        <span>{{ label }}</span>
        <i v-if="help" v-b-tooltip.hover :title="help" class="ml-1 far fa-question-circle"></i>
      </button>
      <span v-else>
        <span v-if="btnText">{{ btnText }}</span>
        <i v-if="!hideIcon" :class="btnIcon ? btnIcon : 'far fa-trash'" class="mx-2"></i>
      </span>
    </a>
    <b-modal ref="container" :title="labelInfo" :hide-footer="true" :size="'sm'" id="mPower-modal-confirm-remove">
      <slot :name="'content'"></slot>
      <div class="form-group d-flex justify-content-end">
        <button class="btn btn-link mr-2" @click="cancel">Cancel</button>
        <button
          class="btn btn-primary"
          data-id="mPower-button-yes"
          data-cy="delete-confirm-button"
          @click="accept"
          v-on:keyup.enter.prevent="accept"
          :disabled="loading"
        >
          Yes <i v-if="loading" class="far fa-spinner-third fa-spin mr-2"></i>
        </button>
      </div>
    </b-modal>
  </span>
</template>
<script>
export default {
  name: 'DeleteButton',
  props: [
    'title',
    'record',
    'remove',
    'variant',
    'btnText',
    'loadingProgress',
    'hideIcon',
    'btnClass',
    'btnIcon',
    'isIcon',
    'disabled',
    'label',
    'help',
    'showTitle'
  ],
  data() {
    return {
      loading: false
    };
  },
  methods: {
    async accept(e) {
      try {
        this.loading = true;
        await this.remove();
        this.cancel();
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
    cancel() {
      if (this.$refs.container) this.$refs.container.hide();
    }
  },
  computed: {
    labelInfo() {
      if (this.help && !this.showTitle) return null;
      return this.label || `Delete ${this.title}?`;
    }
  }
};
</script>
